import { lazy, Suspense } from "react";
import type { RouteObject } from "react-router-dom";

import SignupLayout from "@layout/authLayout/authLayout";
import DefaultLayout from "@layout/defaultLayout";
import MeLayout from "@layout/meLayout/meLayout";
import Error404 from "@pages/error/404";

import Home from "@pages/home";

import { PageLoader } from "@/components/Loader";
import MeInquiryDetailPage from "@/pages/me/inquiry/detail";

import AuthGuard from "./authGuard";
import PathContants from "./pathConstants";

const LoginPage = lazy(() => import("@pages/login"));
const SignupPage = lazy(() => import("@pages/auth/signup"));
const FindIdPage = lazy(() => import("@pages/auth/findId"));
const FindPasswordPage = lazy(() => import("@pages/auth/findPassword"));

const PPFPage = lazy(() => import("@pages/ppf"));

const Brand = lazy(() => import("@pages/brand"));
const Partner = lazy(() => import("@pages/partner"));

// Support
const NoticeListPage = lazy(() => import("@pages/support/notice/list"));
const NoticeDetailPage = lazy(() => import("@pages/support/notice/detail"));
const ContactPage = lazy(() => import("@pages/support/contact"));
const CertificatePage = lazy(() => import("@pages/support/certificate"));

const TermsDetailPage = lazy(() => import("@pages/termsDetail"));

const MeDetailPage = lazy(() => import("@pages/me/detail"));
const MeInquiryPage = lazy(() => import("@pages/me/inquiry"));

export const routes: RouteObject[] = [
	{
		element: (
			<Suspense fallback={<PageLoader />}>
				<DefaultLayout />
			</Suspense>
		),
		errorElement: <Error404 />,
		children: [
			{ path: PathContants.Login, element: <LoginPage /> },
			{
				path: PathContants.Auth,
				element: <SignupLayout />,
				children: [
					{
						path: PathContants.AuthSignup,
						element: <SignupPage />,
						handle: {
							title: "회원가입",
						},
					},
					{
						path: PathContants.AuthFindId,
						element: <FindIdPage />,
						handle: {
							title: "아이디 찾기",
						},
					},
					{
						path: PathContants.AuthFindPassword,
						element: <FindPasswordPage />,
						handle: {
							title: "비밀번호 찾기",
						},
					},
				],
			},
			{ path: PathContants.Home, element: <Home /> },
			{
				path: PathContants.PPF,
				element: <PPFPage />,
			},
			{ path: PathContants.Brand, element: <Brand /> },
			{ path: PathContants.Partner, element: <Partner /> },
			{ path: PathContants.TermsDetail, element: <TermsDetailPage /> },

			{
				path: PathContants.Me,
				handle: { requiresAuth: true },
				element: (
					<AuthGuard>
						<MeLayout />
					</AuthGuard>
				),
				children: [
					{
						path: PathContants.MeDetail,
						index: true,
						element: <MeDetailPage />,
						handle: { requiresAuth: true },
					},
					{
						path: PathContants.meInquiry,
						element: <MeInquiryPage />,
						handle: { requiresAuth: true },
					},
					{
						path: PathContants.meInquiryDetail,
						element: <MeInquiryDetailPage />,
						handle: { requiresAuth: true },
					},
				],
			},
			{
				path: PathContants.Support,
				children: [
					{
						path: PathContants.SupportContact,
						element: <ContactPage />,
					},
					{
						path: PathContants.SupportCertificate,
						element: <CertificatePage />,
					},
					{
						path: PathContants.SupportNotice,
						children: [
							{
								index: true,
								element: <NoticeListPage />,
							},
							{
								path: PathContants.SupportNoticeDetail,
								element: <NoticeDetailPage />,
							},
						],
					},
				],
			},
		],
	},
];
